exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@keyframes _3xqfU1Xt-HgoXWSDnBSsDT {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}", ""]);
// Exports
exports.locals = {
	"tooltipFade": "_3xqfU1Xt-HgoXWSDnBSsDT"
};